import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { isNil } from 'lodash';
import { useEffect, useState } from 'react';
import ProductGroupSelect from './ProductGroupSelect/ProductGroupSelect';
import type { ProductGroupSelectedNode } from './ProductGroupSelect/ProductGroupSelect';
import type { ProductGroup } from 'models/product/productGroup';
import type { FC } from 'react';

interface ProductGroupSelectDialogProps {
  open: boolean;
  onClose: (value?: number) => void;
  dataPostprocessor?: (data: ProductGroup[]) => ProductGroup[];
}

const ProductGroupSelectDialog: FC<ProductGroupSelectDialogProps> = ({
  onClose,
  dataPostprocessor,
  open,
}) => {
  const [selectedGroupId, setSelectedGroupId] = useState<number | undefined>();

  useEffect(() => {
    if (open) setSelectedGroupId(undefined);
  }, [open]);

  const handleClose = (groupId?: number): void => {
    onClose(groupId);
  };

  const handleNodeSelect = (node?: ProductGroupSelectedNode): void => {
    setSelectedGroupId(node?.id);
  };

  return (
    <Dialog
      onClose={() => {
        handleClose();
      }}
      open={open}>
      <DialogTitle>Группы товаров</DialogTitle>
      <DialogContent>
        <ProductGroupSelect
          variant='tree'
          dataPostprocessor={dataPostprocessor}
          onSelectedItemsChange={handleNodeSelect}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleClose(selectedGroupId);
          }}
          disabled={isNil(selectedGroupId)}>
          Выбрать
        </Button>
        <Button
          onClick={() => {
            handleClose();
          }}
          autoFocus>
          Отмена
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProductGroupSelectDialog;
